"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.File = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _Button = require("b2b-components/theme/components/Button");
var _classnames = _interopRequireDefault(require("classnames"));
var _AddedFile = require("./AddedFile");
require("./File.scss");
const File = _ref => {
  let {
    addedFiles,
    className,
    fileInputProps,
    fileRootProps,
    isDisabled,
    isDragActive,
    isMultipleAllowed,
    onOpenClick,
    onRemoveClick,
    onSubmitClick,
    isUploadButtonDisplayed = true,
    text = {
      added: 'Added',
      add: 'Add File...',
      addMultiple: 'Add File(s)...',
      dragActive: 'Drop file here',
      dragActiveMultiple: 'Drop files here',
      dragInactive: 'No file chosen',
      dragInactiveMultiple: 'No files chosen',
      remove: 'Remove file',
      submit: 'Upload File',
      submitMultiple: 'Upload Files'
    }
  } = _ref;
  const rootClassName = (0, _classnames.default)('cds-File', {
    'cds-File--Disabled': isDisabled
  }, className);
  let displayedLabel = '';
  if (!addedFiles?.length && isMultipleAllowed) {
    displayedLabel = isDragActive ? text.dragActiveMultiple : text.dragInactiveMultiple;
  } else if (!addedFiles?.length) {
    displayedLabel = isDragActive ? text.dragActive : text.dragInactive;
  }
  return /*#__PURE__*/_react.default.createElement("div", (0, _extends2.default)({
    className: rootClassName
  }, fileRootProps), /*#__PURE__*/_react.default.createElement("input", fileInputProps), /*#__PURE__*/_react.default.createElement("div", {
    className: "cds-File-AddedFiles"
  }, addedFiles?.map((file, index) => /*#__PURE__*/_react.default.createElement(_AddedFile.AddedFile, {
    fileName: file.name,
    key: index,
    onRemoveClick: onRemoveClick(index),
    text: text
  }))), /*#__PURE__*/_react.default.createElement("div", {
    className: "cds-File-Buttons"
  }, /*#__PURE__*/_react.default.createElement(_Button.Button, {
    className: "cds-File-ChooseButton",
    onClick: onOpenClick,
    size: _Button.BUTTON_SIZE.small,
    styleType: _Button.BUTTON_STYLE_TYPE.light
  }, isMultipleAllowed ? text.addMultiple : text.add), /*#__PURE__*/_react.default.createElement("span", {
    className: "cds-File-Info"
  }, displayedLabel), isUploadButtonDisplayed && /*#__PURE__*/_react.default.createElement(_Button.Button, {
    className: "cds-File-UploadButton",
    isDisabled: !addedFiles?.length,
    onClick: onSubmitClick,
    size: _Button.BUTTON_SIZE.small,
    styleType: _Button.BUTTON_STYLE_TYPE.primary
  }, isMultipleAllowed ? text.submitMultiple : text.submit)));
};
exports.File = File;
//# sourceMappingURL=File.js.map